




























































































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component({})
export default class DlgMemberNew extends Vue {
  public $refs!: {
    form: any,
    image: any,
    logo: any,
  };

  @Action('members/create') private memberCreate!: any;
  @Action('members/read') private memberRead!: any;
  @Action('members/uploadImage') private uploadImage!: any;
  @Getter('rules/all') private rules!: any;

  private newMember: any = {
    password: '',
    guestMember: false,
  };
  private items: string[] = ['Web', 'Restaurant', 'Kleidung'];
  private search: string = '';
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private logoName: string = '';
  private imageName: string = '';

  private imageFile: string = '';
  private imageUrl: string = '';

  private save() {
    if (this.$refs.form.validate()) {
      this.loading = true;
      this.memberCreate(this.newMember).then((success: any) => {
        this.loading = false;
        if (success) {
          this.newMember = {
            guestMember: false,
            logoUrl: '',
            imageUrl: '',
            password: '',
          };
          this.logoName = '';
          this.imageName = '';
          this.imageFile = '';
          this.imageUrl = '';
          this.memberRead();
          this.$refs.form.reset();
          this.dialog = false;
        }
      });
    }
  }

  private pickFile() {
    if (this.loading) {
      return;
    }
    this.$refs.image.click();
  }

  private pickLogo() {
    if (this.loading) {
      return;
    }
    this.$refs.logo.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.imageName = files[0].name;
      if (this.imageName.lastIndexOf('.') <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener('load', () => {
        this.loading = true;
        this.uploadImage(files[0]).then((url: string) => {
          this.loading = false;
          this.newMember.imageUrl = url;
        });
      });
    } else {
      this.imageName = '';
      this.imageFile = '';
      this.imageUrl = '';
    }
  }

  private onLogoPicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.logoName = files[0].name;
      if (this.logoName.lastIndexOf('.') <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener('load', () => {
        this.loading = true;
        this.uploadImage(files[0]).then((url: any) => {
          this.newMember.logoUrl = url;
          this.loading = false;
        });
      });
    } else {
      this.logoName = '';
      this.imageFile = '';
      this.imageUrl = '';
    }
  }

  private generatePassword() {
    this.newMember.password = `${Math.random().toString(36).substr(2, 9)}`;
  }

  private mounted() {
    this.generatePassword();
  }
}
